
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/feature/BottomNav';

const HotelsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState(2);
  const [rooms, setRooms] = useState(1);

  const popularDestinations = [
    { name: 'الرياض', hotels: 245, image: 'https://public.readdy.ai/ai/img_res/5774c87885f9e07c746a20f46b562cb6.jpg' },
    { name: 'جدة', hotels: 189, image: 'https://readdy.ai/api/search-image?query=Jeddah%20waterfront%20hotels%20Red%20Sea%20coast%20Saudi%20Arabia%20modern%20architecture&width=300&height=200&seq=2&orientation=landscape' },
    { name: 'الدمام', hotels: 156, image: 'https://readdy.ai/api/search-image?query=Dammam%20city%20hotels%20Eastern%20Province%20Saudi%20Arabia%20business%20district&width=300&height=200&seq=3&orientation=landscape' },
    { name: 'مكة المكرمة', hotels: 98, image: 'https://readdy.ai/api/search-image?query=Mecca%20holy%20city%20hotels%20Islamic%20architecture%20Saudi%20Arabia%20pilgrimage&width=300&height=200&seq=4&orientation=landscape' }
  ];

  const featuredHotels = [
    {
      id: 1,
      name: 'فندق الريتز كارلتون',
      location: 'الرياض',
      rating: 4.8,
      price: 850,
      image: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20lobby%20elegant%20interior%20marble%20floors%20crystal%20chandeliers%20five%20star%20hospitality&width=300&height=200&seq=5&orientation=landscape',
      amenities: ['واي فاي مجاني', 'مسبح', 'سبا', 'مطعم']
    },
    {
      id: 2,
      name: 'فندق الفيصلية',
      location: 'الرياض',
      rating: 4.6,
      price: 720,
      image: 'https://readdy.ai/api/search-image?query=modern%20hotel%20room%20king%20bed%20city%20view%20floor%20to%20ceiling%20windows%20luxury%20amenities&width=300&height=200&seq=6&orientation=landscape',
      amenities: ['واي فاي مجاني', 'صالة رياضية', 'مطعم', 'خدمة الغرف']
    },
    {
      id: 3,
      name: 'فندق شيراتون',
      location: 'جدة',
      rating: 4.4,
      price: 650,
      image: 'https://readdy.ai/api/search-image?query=hotel%20swimming%20pool%20area%20palm%20trees%20resort%20style%20relaxation%20luxury%20vacation&width=300&height=200&seq=7&orientation=landscape',
      amenities: ['واي فاي مجاني', 'مسبح', 'مطعم', 'موقف سيارات']
    }
  ];

  const hotelChains = [
    { name: 'ماريوت', logo: 'https://readdy.ai/api/search-image?query=icon%20hotel%20chain%20logo%20Marriott%20brand%20hospitality%20luxury%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=8&orientation=squarish' },
    { name: 'هيلتون', logo: 'https://readdy.ai/api/search-image?query=icon%20hotel%20chain%20logo%20Hilton%20brand%20hospitality%20luxury%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=9&orientation=squarish' },
    { name: 'شيراتون', logo: 'https://readdy.ai/api/search-image?query=icon%20hotel%20chain%20logo%20Sheraton%20brand%20hospitality%20luxury%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=10&orientation=squarish' },
    { name: 'ريتز كارلتون', logo: 'https://readdy.ai/api/search-image?query=icon%20hotel%20chain%20logo%20Ritz%20Carlton%20brand%20hospitality%20luxury%20service%20isolated%20on%20white%20background%20centered%20composition&width=100&height=100&seq=11&orientation=squarish' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm fixed top-0 left-0 right-0 z-10 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <button 
            onClick={() => navigate('/home')}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
          <h1 className="text-lg font-semibold text-gray-900 truncate mx-4">الفنادق</h1>
          <button className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0">
            <i className="ri-notification-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 pb-20">
        {/* Search Form */}
        <div className="bg-white p-4 shadow-sm">
          <div className="space-y-4">
            {/* Destination */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">الوجهة</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="أين تريد الإقامة؟"
                  className="w-full p-3 pr-10 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <i className="ri-map-pin-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              </div>
            </div>

            {/* Dates */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تسجيل الوصول</label>
                <input
                  type="date"
                  value={checkIn}
                  onChange={(e) => setCheckIn(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تسجيل المغادرة</label>
                <input
                  type="date"
                  value={checkOut}
                  onChange={(e) => setCheckOut(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-5   focus:border-transparent text-sm"
                />
              </div>
            </div>

            {/* Guests & Rooms */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">النزلاء</label>
                <div className="flex items-center border border-gray-200 rounded-xl p-3">
                  <button
                    onClick={() => setGuests(Math.max(1, guests - 1))}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200"
                  >
                    <i className="ri-subtract-line text-sm"></i>
                  </button>
                  <span className="flex-1 text-center font-medium">{guests}</span>
                  <button
                    onClick={() => setGuests(guests + 1)}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200"
                  >
                    <i className="ri-add-line text-sm"></i>
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">الغرف</label>
                <div className="flex items-center border border-gray-200 rounded-xl p-3">
                  <button
                    onClick={() => setRooms(Math.max(1, rooms - 1))}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200"
                  >
                    <i className="ri-subtract-line text-sm"></i>
                  </button>
                  <span className="flex-1 text-center font-medium">{rooms}</span>
                  <button
                    onClick={() => setRooms(rooms + 1)}
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200"
                  >
                    <i className="ri-add-line text-sm"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Search Button */}
            <button className="w-full bg-blue-600 text-white py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors">
              البحث عن فنادق
            </button>
          </div>
        </div>

        {/* Popular Destinations */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">الوجهات الشائعة</h2>
          <div className="grid grid-cols-2 gap-3">
            {popularDestinations.map((destination, index) => (
              <div key={index} className="relative rounded-xl overflow-hidden">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-32 object-cover"
                />
                <div className="absolute inset-0 bg-black/30 flex flex-col justify-end p-3">
                  <h3 className="text-white font-semibold">{destination.name}</h3>
                  <p className="text-white/80 text-sm">{destination.hotels} فندق</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hotel Chains */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">سلاسل الفنادق</h2>
          <div className="grid grid-cols-4 gap-3">
            {hotelChains.map((chain, index) => (
              <div key={index} className="bg-white rounded-xl p-3 shadow-sm text-center">
                <img
                  src={chain.logo}
                  alt={chain.name}
                  className="w-12 h-12 mx-auto mb-2 object-contain"
                />
                <p className="text-xs text-gray-600 font-medium">{chain.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Hotels */}
        <div className="p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">فنادق مميزة</h2>
          <div className="space-y-4">
            {featuredHotels.map((hotel) => (
              <div key={hotel.id} className="bg-white rounded-xl shadow-sm overflow-hidden">
                <img
                  src={hotel.image}
                  alt={hotel.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h3 className="font-semibold text-gray-900">{hotel.name}</h3>
                      <p className="text-sm text-gray-600 flex items-center">
                        <i className="ri-map-pin-line text-xs ml-1"></i>
                        {hotel.location}
                      </p>
                    </div>
                    <div className="text-left">
                      <div className="flex items-center">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <span className="text-sm font-medium text-gray-900 mr-1">{hotel.rating}</span>
                      </div>
                      <div className="text-lg font-bold text-blue-600">{hotel.price} ر.س</div>
                      <div className="text-xs text-gray-500">لليلة الواحدة</div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3">
                    {hotel.amenities.map((amenity, index) => (
                      <span key={index} className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                        {amenity}
                      </span>
                    ))}
                  </div>
                  <button className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors">
                    عرض التفاصيل
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default HotelsPage;
